import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { LocationSetTypesComponent } from '@emm/management/components/location-set-types/location-set-types.component';

@Injectable({
    providedIn: 'root'
})
export class ConfirmLocationSetTypesDeactivateGuard  {

    canDeactivate(
        component: LocationSetTypesComponent,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return component
            .checkIfItemHasChanges(component.prevLocationSetType)
            .pipe(take(1));
    }

}
